import * as actionTypes from './actionTypes';

export const setLastSearch = ( lastSearch: any ) => {
    return {
        type: actionTypes.LAST_SEARCH_SET,
        fields: lastSearch
    };
};
